import { c as _c } from "react/compiler-runtime";
import { Formik } from 'formik';
import { HookdeckAPIError } from '../../client/Hookdeck';
import Button from './base/Button';
import { StyledCardSection } from './base/Card';
import Dropdown from './Dropdown';
import TextAreaInput from './Form/Fields/TextAreaInput';
export const getAIErrorMessage = (error: unknown, fallback: string) => {
  if (error instanceof HookdeckAPIError && typeof error.response === 'object' && error.response?.code === 'AI_FEATURES_UNAVAILABLE') {
    return error.response.message;
  }
  return fallback;
};
interface AIPromptDropdownProps {
  label: string;
  placeholder: string;
  submit_label: string;
  small?: boolean;
  // Custom toggle, defaults to a ghost button with the label.
  renderToggle?: (opened: boolean, toggle: (opened: boolean) => void) => JSX.Element;
  // Resolves to true when the generated result was applied, which closes the dropdown.
  onSubmit: (prompt: string) => Promise<boolean>;
}
const AIPromptDropdown: React.FC<AIPromptDropdownProps> = t0 => {
  const $ = _c(10);
  const {
    label,
    placeholder,
    submit_label,
    small,
    renderToggle,
    onSubmit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      min: 480,
      max: 480
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onSubmit || $[2] !== placeholder || $[3] !== submit_label) {
    t2 = toggle => <Formik initialValues={{
      prompt: ""
    }} onSubmit={values => onSubmit(values.prompt.trim()).then(applied => applied && toggle(false))}>{t3 => {
        const {
          submitForm,
          isSubmitting,
          values: values_0
        } = t3;
        return <><StyledCardSection p={4}><TextAreaInput name="prompt" rows={4} maxlength={4000} focus={true} placeholder={placeholder} m={0} /></StyledCardSection><StyledCardSection p={{
            x: 4,
            y: 3
          }} flex={{
            justify: "flex-end"
          }}><Button primary={true} type="button" disabled={isSubmitting || !values_0.prompt.trim()} icon={isSubmitting ? "loading" : "auto_awesome"} onClick={submitForm}>{submit_label}</Button></StyledCardSection></>;
      }}</Formik>;
    $[1] = onSubmit;
    $[2] = placeholder;
    $[3] = submit_label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== label || $[6] !== renderToggle || $[7] !== small || $[8] !== t2) {
    t3 = <Dropdown placement="bottom-end" z_index={1080} icon="auto_awesome" ghost={true} small={small} label={label} renderToggle={renderToggle} parent_width={t1} expand_icon="chevron_down">{t2}</Dropdown>;
    $[5] = label;
    $[6] = renderToggle;
    $[7] = small;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default AIPromptDropdown;